// extracted by mini-css-extract-plugin
export var inline = "NavSocialMedia-module--inline--qC6gc";
export var socialsLabel = "NavSocialMedia-module--socialsLabel--Il0HY";